import { useState } from 'react';
import api from '../services/api';
import { useToast } from '../contexts/ToastContext';

export default function BookingEditForm({ booking, onSaved, onCancel }) {
  const { addToast } = useToast();
  const [editFormData, setEditFormData] = useState({
    proposedFee: booking.proposedFee ? (booking.proposedFee / 100).toString() : '',
    currency: booking.currency || 'EUR',
    technicalRequirements: booking.technicalRequirements || '',
    travelIncluded: booking.travelIncluded || false,
    accommodationIncluded: booking.accommodationIncluded || false,
    notes: booking.notes || '',
  });

  async function handleSaveEdit() {
    try {
      // Tous les champs sont envoyés (null quand vidés) : le backend met à jour
      // tel quel toute valeur !== undefined, ce qui permet de vider un champ.
      const payload = {
        technicalRequirements: editFormData.technicalRequirements.trim() || null,
        notes: editFormData.notes.trim() || null,
        travelIncluded: editFormData.travelIncluded,
        accommodationIncluded: editFormData.accommodationIncluded,
      };
      if (editFormData.proposedFee) {
        payload.proposedFee = Math.round(parseFloat(editFormData.proposedFee) * 100);
        payload.currency = editFormData.currency;
      } else {
        payload.proposedFee = null;
      }

      const res = await api.put(`/bookings/${booking.id}`, payload);
      onSaved(res.data.booking || { ...booking, ...res.data });
      addToast('Booking mis à jour');
    } catch (err) {
      addToast(err.message, 'error');
    }
  }

  return (
    <div className="th-bg p-5 space-y-4">
      <div className="grid grid-cols-[2fr_1fr] gap-3">
        <div>
          <label className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
            Cachet proposé
          </label>
          <input
            type="number"
            value={editFormData.proposedFee}
            onChange={(e) => setEditFormData((prev) => ({ ...prev, proposedFee: e.target.value }))}
            min="0"
            step="100"
            placeholder="Montant"
            className="th-input w-full"
          />
        </div>
        <div>
          <label className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
            Devise
          </label>
          <select
            value={editFormData.currency}
            onChange={(e) => setEditFormData((prev) => ({ ...prev, currency: e.target.value }))}
            className="bg-transparent border th-border th-text text-sm focus:border-accent outline-none transition-colors duration-150 px-3 py-2.5 w-full"
          >
            <option value="EUR">EUR</option>
            <option value="USD">USD</option>
            <option value="GBP">GBP</option>
          </select>
        </div>
      </div>
      <div>
        <label className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
          Rider technique
        </label>
        <textarea
          value={editFormData.technicalRequirements}
          onChange={(e) => setEditFormData((prev) => ({ ...prev, technicalRequirements: e.target.value }))}
          maxLength={5000}
          rows={2}
          placeholder="Exigences techniques"
          className="th-input resize-none w-full"
        />
      </div>
      <div className="space-y-2">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={editFormData.travelIncluded}
            onChange={(e) => setEditFormData((prev) => ({ ...prev, travelIncluded: e.target.checked }))}
            className="w-4 h-4"
          />
          <span className="text-xs font-mono th-text-secondary uppercase tracking-widest">Voyage inclus</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={editFormData.accommodationIncluded}
            onChange={(e) => setEditFormData((prev) => ({ ...prev, accommodationIncluded: e.target.checked }))}
            className="w-4 h-4"
          />
          <span className="text-xs font-mono th-text-secondary uppercase tracking-widest">Hébergement inclus</span>
        </label>
      </div>
      <div>
        <label className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
          Notes internes
        </label>
        <textarea
          value={editFormData.notes}
          onChange={(e) => setEditFormData((prev) => ({ ...prev, notes: e.target.value }))}
          maxLength={2000}
          rows={2}
          placeholder="Notes internes"
          className="th-input resize-none w-full"
        />
      </div>
      <div className="flex gap-3 pt-2">
        <button
          onClick={handleSaveEdit}
          className="th-btn-accent flex-1"
        >
          Enregistrer
        </button>
        <button
          onClick={onCancel}
          className="th-btn flex-1"
        >
          Annuler
        </button>
      </div>
    </div>
  );
}
